export const CHAT_REACTION_CONFIG = Object.freeze([
  { type: 'good', label: 'Good', iconClassName: 'fa-solid fa-thumbs-up' },
  { type: 'heart', label: 'ハート', iconClassName: 'fa-solid fa-heart' },
  { type: 'thanks', label: 'ありがとう', iconClassName: 'fa-solid fa-hands-clapping' },
  { type: 'please', label: 'お願いします', iconClassName: 'fa-solid fa-hands-praying' },
]);

export const CHAT_REACTION_CONFIG_MAP = Object.freeze(
  CHAT_REACTION_CONFIG.reduce((accumulator, item) => {
    accumulator[item.type] = item;
    return accumulator;
  }, {}),
);
